
import { mixins, Options } from 'vue-class-component';
import CartWidgetMixin from '@/mixins/cartWidget';
import LazyImage from '../LazyImage.vue';

@Options({
  components: {
    LazyImage
  }
})
export default class MTokenExclusiveWarning extends mixins(CartWidgetMixin) {
  get starFavorite() {
    if (this.customStarImage) {
      return this.customStarImage;
    } else {
      return require('@/assets/images/star-favorite.svg');
    }
  }

  get openseaLink() {
    if (this.openSeaCollectionSlug) {
      return `https://opensea.io/collection/${this.openSeaCollectionSlug}`;
    } else {
      return 'https://opensea.io';
    }
  }

  get eligibleTokensTitle() {
    if (this.noEligibleTokensTitle) {
      return this.noEligibleTokensTitle;
    } else {
      return this.state && this.state.campaign && this.state.campaign.snapshot
        ? 'Snapshot Token Holder Exclusive'
        : 'Token Exclusive';
    }
  }

  get eligibleTokensMessage() {
    if (this.noEligibleTokensMessage) {
      return this.noEligibleTokensMessage;
    } else {
      return `You don't have eligible tokens.`;
    }
  }
}
